import config from '../config';

const apiUrl = config.apiUrl;


export const uploadFiles = (data) => {
    return fetch(apiUrl + "/api/upload", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        //   'Content-Type': 'application/json'
        },
        body: data
      });
};

export const uploadFilesFast = (data) => {
    return fetch(apiUrl + "/api/upload/photos/fast", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        //   'Content-Type': 'application/json'
        },
        body: data
      })
      .then(response => {
        if (response.ok) {
          return response.json().then(result => {
            // Transform new API response to match old API format
            if (result.uploads && result.uploads.length > 0) {
              const firstUpload = result.uploads[0];
              return {
                status: 200,
                json: () => Promise.resolve({
                  url: firstUpload.url,
                  directLink: firstUpload.url,
                  key: firstUpload.key,
                  originalName: firstUpload.originalName,
                  size: firstUpload.size,
                  contentType: firstUpload.contentType,
                  uploadTime: firstUpload.uploadTime
                })
              };
            }
            return {
              status: 500,
              json: () => Promise.resolve(result)
            };
          });
        }
        return {
          status: response.status,
          json: () => Promise.resolve({error: 'Upload failed'})
        };
      });
};

const objToQueryString = (obj) => {
    const keyValuePairs = [];
    for (const key in obj) {
      keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
    return keyValuePairs.join('&');
  }

